import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  adminTextInput: {
    width: '100%',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderRadius: '5px',
    padding: '0em 0em 0em .4em',
    '& input, & textarea': {
      color: theme.palette.text.primary,
    },
  },
  adminTextInputLabel: {
    margin: '17px 0 7px 0',
    color: theme.palette.text.secondary,
  },

  administrationPage: {
    backgroundColor: theme.palette.background.default,
  },
  drawerAndContentWrapper: {
    paddingTop: '45px',
    display: 'flex',
    height: '100%',
  },
  paginationWrapper: {
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
  },
  accessDeny: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  accessDenyText: {
    textAlign: 'center',
    color: theme.palette.error.main,
    fontSize: '40px',
    padding: '400px 0 50px 0',
  },
  goHomeButton: {
    width: '200px',
    margin: 'auto',
  },
}));

export default useStyles;
